import styled from "styled-components";
import {
  GridColDef,
  GridValueFormatterParams,
  GridValueGetterParams,
} from "@mui/x-data-grid";
import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { LoadingBackDrop } from "../../../components/loader";
import { useNavigate } from "react-router-dom";
import { Button } from "@mui/material";
import { size, theme } from "../../../helpers/theme";
import { StyledTable } from "../../../components/table/styled-table";
import {
  dateFormating,
  getPurposeFromEnum,
  getServiceFromEnum,
  getStatusFromEnum,
  getTypeFromEnum,
} from "../../operator-views/operator-orders-offering/helpers";
import { getAllClientOrders } from "../../../services/orders/get-logged";
import { GetAllClientOrdersPayload } from "../../../services/orders/get-logged/types";
import { urlClient } from "../../../utils/url";
import SessionService from "../../../services/session-service";
import { OfferViewInClientPanel } from "../offer-view-in-client-panel";
import { styled as _styled } from "@mui/material/styles";
import { StyledButton } from "../../../components/Button/button";
import { getAllWarehouses } from "../../../services/warehouses/get-all";
import { warehouses } from "../../../redux/actions";

const ClientOrders = () => {
  const navigate = useNavigate();
  const [offerView, setOfferView] = useState();

  const columns: GridColDef[] = [
    {
      field: "",
      headerName: "Akcje",
      width: 250,
      sortable: false,
      filterable: false,
      hideable: false,
      renderCell: (params) => (
        <>
          <Button
            variant="contained"
            style={{
              backgroundColor: theme.colors.blue01_active,
            }}
            onClick={() => {
              return navigate(`/orders/${params.id}`);
            }}
          >
            Szczegóły
          </Button>
          {params.row.status_zamowienia === "Nowe" ||
          params.row.status_zamowienia === "Do ostatecznej akceptacji" ? (
            <Button
              variant="contained"
              style={{
                marginLeft: "10px",
                backgroundColor: "orange",
              }}
              onClick={() => {
                if (params.row.status_zamowienia === "Nowe") {
                  navigate(`/orders/offer-view/${params.id}`);
                } else if (
                  params.row.status_zamowienia === "Do ostatecznej akceptacji"
                ) {
                  navigate(`/orders/final-offer-view/${params.id}`);
                } else {
                  navigate(``);
                }
              }}
            >
              Oferty
            </Button>
          ) : null}
        </>
      ),
    },
    { field: "numer_zamowienia", headerName: "Numer zamówienia", width: 450 },
    { field: "status_zamowienia", headerName: "Status", width: 200 },
    { field: "miasto", headerName: "Miasto", width: 200 },
    {
      field: "usluga",
      headerName: "Usługa",
      valueFormatter: (params: GridValueFormatterParams) => {
        return getServiceFromEnum(params.value);
      },
      valueGetter: (params: GridValueGetterParams) => {
        return params.value;
      },
      width: 200,
    },
    {
      field: "data_zlozenia",
      type: "date",
      valueFormatter: (params: GridValueFormatterParams) => {
        return dateFormating(params.value);
      },
      valueGetter: (params: GridValueGetterParams) => {
        return params.value;
      },
      headerName: "Data złożenia",
      width: 200,
    },
  ];

  const [orders, setOrders] = useState<GetAllClientOrdersPayload[]>([]);

  const body = {
    paginacja: null,
  };
  const getAllWarehousesClient = useQuery(
    ["warehouses"],
    () => getAllWarehouses(body),
    {
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      onSuccess(data) {
        SessionService.setWarehousesList(data.data.payload.magazyny);
      },
    }
  );
  const GetAllClientOrders = useQuery(
    ["AllOrders"],
    () => getAllClientOrders(body),
    {
      refetchOnMount: true,
      refetchOnWindowFocus: false,

      onSuccess(data) {
        setOrders(data.data.payload.zamowienia);
      },
    }
  );

  const rows = orders.map((r) => ({
    id: r.id_zamowienie,
    numer_zamowienia: r.numer_zamowienia,
    data_zlozenia: r.data_zlozenia,
    usluga: r.uslugi_zamowione.cel_zamowienia,
    status_zamowienia: getStatusFromEnum(r.status_zamowienia),
    miasto: r.miasto,
  }));

  if (
    GetAllClientOrders.isLoading ||
    GetAllClientOrders.isRefetching ||
    getAllWarehousesClient.isLoading ||
    getAllWarehousesClient.isRefetching
  ) {
    return <LoadingBackDrop loading={true} />;
  }

  return (
    <OrdersContainer>
      <AddNewOrderButtonWrapper>
        <StyledButton
          variant="contained"
          onClick={() => {
            return navigate(urlClient.orderForm);
          }}
        >
          Nowe zamówienie
        </StyledButton>
      </AddNewOrderButtonWrapper>
      <StyledTable
        getRowId={(row: any) => row?.id}
        rows={rows}
        columns={columns}
        // pageSize={5}
        // rowsPerPageOptions={[5]}
        // autoHeight
        autoPageSize
      />
    </OrdersContainer>
  );
};

export default ClientOrders;

const OrdersContainer = styled.div`
  margin-top: -18px;
  height: 80vh;
  display: flex;
  flex-direction: column;
  margin-left: 0;
  padding-right: 0;

  @media (min-width: 1025px) {
    margin-left: 225px;
    margin-right: 50px;
  }
`;
const AddNewOrderButtonWrapper = styled.div`
  display: flex;
  margin-left: 6px;
  margin-bottom: 30px;
`;
export const StyledClientTable = _styled(StyledTable)({
  ".row-style": {
    maxHeight: "110px !important",
    height: "110px",
  },

  "& .MuiDataGrid-cell": {
    maxHeight: "100% !important",
    flexWrap: "wrap",
    justifyContent: "space-between",
    padding: "8px 10px ",
  },
});
